import React from 'react';
import styled from 'styled-components';

const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;

    .labelContainer {
      margin-left: 10px;
    }
  }

  .row:not(:last-child) {
    margin-bottom: 10px;
  }

  .name {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 14px;
    font-weight: 600;
    color: #1c2b38;
  }

  .name span {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-weight: normal;
  }

  .totalValue {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    color: #4b4b4b;
  }
`;

const Color = styled.div`
  width: 50px;
  height: 25px;
  background-color: ${(props) => props.color};
`;

const COLORS = ['#293442', '#525d69', '#7b838b', '#a4abae', '#d0d4d3'];

const Legend = ({ labels = [] }) => (
  <LegendContainer>
    {labels.map((item, index) => (
      <div key={item.label} className="row">
        <Color color={COLORS[index]} />
        <div className="labelContainer">
          <p className="name">
            {item.label} - {item.percentage}
          </p>
          <p className="totalValue">{item.subLabel}</p>
        </div>
      </div>
    ))}
  </LegendContainer>
);

export default Legend;
